@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
